// @ts-nocheck
import { toast } from "sonner";
export function validatePhone(input_phone) {
   // return Boolean( String(input_phone).match(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/) );
   const pilotNumberRegex = /^[a-zA-Z0-9]{1,10}$/; // Allow alphanumeric characters up to 10 characters
   return pilotNumberRegex.test(input_phone);
}

export const validateEmail = (email) => {
   const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
   if (!email) {
     return "Email is required";
   } else if (!emailPattern.test(email)) {
     return "Invalid email format";
   }
   return "";
 };

export function getUsernameValidationError(value) {
  const trimmedValue = String(value || "").trim();
  if (!trimmedValue) {
    return "Username is required";
  }
  if (trimmedValue.length < 3 || trimmedValue.length > 50) {
    return "Username must be between 3 and 50 characters";
  }
  if (!/^[a-zA-Z0-9_ ]+$/.test(trimmedValue)) {
    return "Username can only contain letters, numbers, underscores, and spaces";
  }
  return "";
}

export function getNameValidationError(value) {
  const trimmedValue = String(value || "").trim();
  if (!trimmedValue) {
    return "Name is required";
  }
  if (trimmedValue.length < 2 || trimmedValue.length > 100) {
    return "Name must be between 2 and 100 characters";
  }
  if (!/^[a-zA-Z0-9_ ]+$/.test(trimmedValue)) {
    return "Name can only contain letters, numbers, underscores, and spaces";
  }
  return "";
}

export function getAgentNameFieldError(value, existingNames) {
  const trimmedValue = String(value || "").trim();
  if (!trimmedValue) {
    return "Agent Name is required";
  }
  if (!/^[a-zA-Z0-9_]+$/.test(trimmedValue)) {
    return "Agent Name can only contain letters, numbers, and underscores (_). No spaces or special characters allowed.";
  }
  const key = trimmedValue.toLowerCase();
  const taken =
    existingNames instanceof Set
      ? existingNames.has(key)
      : Array.isArray(existingNames) &&
        existingNames.some((n) => String(n).trim().toLowerCase() === key);
  if (taken) {
    return "Agent name must be unique within this call centre. This name is already in use.";
  }
  return "";
}

export function getScriptTitleValidationError(value) {
  const trimmedValue = String(value || "").trim();
  if (!trimmedValue) {
    return "Script title is required";
  }
  if (trimmedValue.length < 2 || trimmedValue.length > 100) {
    return "Script title must be between 2 and 100 characters";
  }
  if (!/^[a-zA-Z0-9_ ]+$/.test(trimmedValue)) {
    return "Script title can only contain letters, numbers, underscores, and spaces";
  }
  return "";
}

export const SCRIPT_EDITOR_CONFIG = {
  toolbar: {
    removeItems: ["uploadImage", "imageUpload", "insertImage", "mediaEmbed"],
  },
};

export const SCRIPT_SHORT_DESCRIPTION_MAX = 512;
export const SCRIPT_DESCRIPTION_MAX = 5000;

export function getLengthError(value, max, label) {
  const length = String(value ?? "").length;
  return length > max
    ? `${label} must be at most ${max} characters (currently ${length})`
    : "";
}

export function stripHtmlTags(html) {
  if (html == null || html === "") return "";
  return String(html)
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/&quot;/gi, '"')
    .replace(/\s+/g, " ")
    .trim();
}

export function getUsernameTakenMessage(username, existingUsernames = []) {
  const trimmed = String(username || "").trim().toLowerCase();
  if (!trimmed) return "";
  const isTaken = existingUsernames.some(
    (existing) => String(existing).trim().toLowerCase() === trimmed
  );
  return isTaken ? `Username "${trimmed}" already exists` : "";
}
 
export const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

export const getCurrentTime = () => {
  const now = new Date();
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  return `${hours}:${minutes}`;
};

export const getCurrentDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const hasPermission = (
  moduleOperations,
  module,
  operation,
) => {

  return !!moduleOperations?.[module]?.[operation];
};

export {
  getAllowedVoicePlanDirections,
  canUseVoicePlanType,
  parseModuleOperations,
  VOICE_PLAN_ACL_MODULE,
} from "./voicePlanAcl";

export {
  getVoiceLibraryAclRestrictions,
  filterVoiceTypesByAcl,
  filterLanguagesByAcl,
  VOICE_LIBRARY_ACL_MODULE,
} from "./voiceLibraryAcl";

const csvEscape = (value) => {
  let s = String(value ?? "");
  if (typeof value === "string" && /^([=+@\t\r]|-(?![\d.]|$))/.test(s)) s = `'${s}`;
  return `"${s.replace(/"/g, '""')}"`;
};

export const formatErrorDesc = (v) => {
  const s = v == null ? '' : String(v).trim();
  return !s || /^(null|undefined)$/i.test(s) ? '-' : s;
};

/**
 * Export rows as CSV.
 *
 * Preferred: exportToCSV({ data, fileName, columns })
 * Legacy:    exportToCSV(arrayOfObjects, fileName)
 *
 * Accessors receive (row, index). Headers are quoted so a "#" column is not
 * treated as a CSV comment. A UTF-8 BOM is prepended so Excel keeps ₹/Unicode.
 */
export const exportToCSV = (arg1, arg2) => {
  try {
    let data = [];
    let fileName = "export";
    let columns = [];

    if (Array.isArray(arg1)) {
      data = arg1;
      fileName = arg2 || "export";
      if (!data.length) return;
      columns = Object.keys(data[0]).map((key) => ({
        header: key,
        accessor: (row) => row[key],
      }));
    } else {
      data = arg1?.data ?? [];
      fileName = arg1?.fileName ?? "export";
      columns = arg1?.columns ?? [];
    }

    if (!data.length || !columns.length) return;

    const headers = columns.map((col) => csvEscape(col.header));

    const rows = data.map((row, index) =>
      columns.map((col) => {
        let value =
          typeof col.accessor === "function"
            ? col.accessor(row, index)
            : row[col.accessor];
        return csvEscape(value);
      })
    );

    const csvContent =
      "\uFEFF" + [headers, ...rows].map((r) => r.join(",")).join("\n");

    const blob = new Blob(
      [csvContent],
      { type: "text/csv;charset=utf-8;" }
    );

    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);

    link.href = url;
    link.download = `${fileName}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  } catch (err) {
    console.log("Export failed:", err);
    toast.error("Failed to export data. Please try again.");
  }
};

export function sortExtensionsAscending(list) {
  return [...(Array.isArray(list) ? list : [])].sort((a, b) =>
    String(a?.extension ?? a?.username ?? "").localeCompare(
      String(b?.extension ?? b?.username ?? ""),
      undefined,
      { numeric: true, sensitivity: "base" },
    ),
  );
}

const EXTENSION_LOCAL_VALID = /^[1-4][0-9]{0,3}$/;
const EXTENSION_LOCAL_HINT =
  "First digit must be 1–4 (not 0); remaining digits may be 0–9. Max 4 digits.";

function storedExtensionMatchesFull(stored, full) {
  if (stored === "" || stored == null) return false;
  const storedStr = String(stored);
  const fullStr = String(full);
  if (storedStr === fullStr) return true;
  const storedNum = Number(storedStr);
  const fullNum = Number(fullStr);
  return !Number.isNaN(storedNum) && !Number.isNaN(fullNum) && storedNum === fullNum;
}

export function getDefaultExtensionFieldError(local, existingExtensions, namespace) {
  const value = String(local || "").trim();
  if (!value) return "";
  if (!EXTENSION_LOCAL_VALID.test(value)) return EXTENSION_LOCAL_HINT;

  const ns = String(namespace || "");
  if (!ns) return "";

  const full = `${ns}${value}`;
  const nsNumeric = String(Number(ns));
  const rows = Array.isArray(existingExtensions) ? existingExtensions : [];

  const taken = rows.some((row) => {
    const username = String(row?.username || "");
    const stored = row?.extension == null || row?.extension === "" ? "" : String(row.extension);

    if (username === full) return true;
    if (storedExtensionMatchesFull(stored, full)) return true;

    if (username.startsWith(ns) && username.slice(ns.length) === value) return true;
    if (stored.startsWith(ns) && stored.slice(ns.length) === value) return true;
    if (
      nsNumeric &&
      stored.startsWith(nsNumeric) &&
      stored.length > nsNumeric.length &&
      stored.slice(nsNumeric.length) === value
    ) {
      return true;
    }
    return false;
  });

  return taken ? "Extension Already Exists" : "";
}

export function toRupeeFixed(amount: number) {
  const hasSubPaisa = Math.abs(amount - Number(amount.toFixed(2))) > 1e-9;
  return amount.toFixed(hasSubPaisa ? 4 : 2);
}

export function formatRupeeAmount(value) {
  if (value === null || value === undefined || value === "") return "-";
  const amount = Number(value);
  if (Number.isNaN(amount)) return String(value);
  return `₹${toRupeeFixed(amount)}`;
}